import { BaseBloc } from '@core/utils/bloc';
import { Repository } from '@core/utils/repository';
import { TaskLinkableAPI } from '@business/api/task_linkable';
import { TaskId, TaskLinkableResponse, CreateTaskLinkRequest, SearchEntityRequest, TaskLinkableId } from '@business/entities/task';
import { handleMessage, requestMessage } from '@business/messages';
import { switchMap } from 'rxjs/operators';
import { showDeleteConfirmation } from '@modules/common';

export class TaskLinkableBloc extends BaseBloc {
  private readonly taskLinkableRepo = new Repository<TaskLinkableResponse>({
    getItemId: taskLink => taskLink.id,
  });

  readonly items$ = this.taskLinkableRepo.items$;
  readonly selectTaskLinkable = this.taskLinkableRepo.selectItem;

  onReset() {
    this.taskLinkableRepo.reset();
  }

  fetchTaskLinks = (taskId: TaskId) => {
    return TaskLinkableAPI.fetchTaskLinks(taskId).pipe(
      //   this.taskLinkableRepo.ops.reset(),
      this.taskLinkableRepo.ops.upsertMany(item => ({ item })),
      handleMessage({ error: requestMessage('fetch_task_links_error') }),
    );
  };

  createTaskLink = (request: CreateTaskLinkRequest) => {
    return TaskLinkableAPI.createTaskLink(request).pipe(
      this.taskLinkableRepo.ops.addOne(item => item),
      handleMessage({
        type: requestMessage('create_task_link_success'),
      }),
    );
  };

  deleteTaskLink = (taskLinkableId: TaskLinkableId) => {
    return showDeleteConfirmation('Delete linked item', `Do you really want to remove this linked item?`).pipe(
      switchMap(() => TaskLinkableAPI.deleteTaskLink(taskLinkableId)),
      this.taskLinkableRepo.ops.removeOne(() => taskLinkableId),
      //   handleMessage({
      //     type: requestMessage('delete_task_link_success'),
      //   }),
    );
  };

  searchEntities = (request: SearchEntityRequest) => {
    return TaskLinkableAPI.searchEntities(request).pipe(handleMessage({ error: requestMessage('search_entities_error') }));
  };
}
